import { useContext, type ReactNode } from 'react';
import DocumentContext from '../contexts/DocumentContext.context';
import NavBlockInsights from '../components/nav/NavBlockInsights';
import NavDocumentInsights from '../components/nav/NavDocumentInsights';
import NavHeadings from '../components/nav/NavHeadings';

const useDocumentNavTabs = (): { Headings?: ReactNode; Insights?: ReactNode } => {
  // Missing while no document is shown.
  const documentContext = useContext(DocumentContext);
  if (!documentContext) return {};
  const { doc, version, resolvedItems } = documentContext;
  if (doc.isBlock)
    return { Insights: <NavBlockInsights block={doc} version={version} resolvedItems={resolvedItems} /> };
  return { Headings: <NavHeadings />, Insights: <NavDocumentInsights /> };
};

export default useDocumentNavTabs;
